import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw7000Handlers = [
  // 特集商品選定チェック /kymw70/checkFeatureGoodsSelection
  http.post(PlessService.SERVICE.checkFeatureGoodsSelection.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.checkFeatureGoodsSelection.url, req);
    return HttpResponse.json(checkFeatureGoodsSelectionResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  // 表紙特集商品選定情報チェック /kymw70/checkFeatureSelection
  http.post(PlessService.SERVICE.checkFeatureSelection.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.checkFeatureSelection.url, req);
    return HttpResponse.json(checkFeatureSelectionResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 表紙特集商品選定情報確定(企画担当) /kymw70/confirmFeatureInfoByPlanner
  http.post(PlessService.SERVICE.confirmFeatureInfoByPlanner.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.confirmFeatureInfoByPlanner.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 表紙特集商品選定情報ダウンロード /kymw70/downloadFeatureGoods
  http.post(PlessService.SERVICE.downloadFeatureGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.downloadFeatureGoods.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集情報一覧取得 /kymw70/getFeatureList
  http.post(PlessService.SERVICE.KYMW70getFeatureList.url,async ({ request }) => {
      const req = await request.json();
      console.log(PlessService.SERVICE.KYMW70getFeatureList.url, req);
      return HttpResponse.json(getFeatureListResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 特集情報取得 /kymw70/getFeatureThema
  http.post(PlessService.SERVICE.KYMW70getFeatureThema.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getFeatureThema.url, req);
    return HttpResponse.json(getFeatureThemaResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品基本情報取得 /kymw70/getGoodsBase
  http.post(PlessService.SERVICE.KYMW70getGoodsBase.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getGoodsBase.url, req);
    return HttpResponse.json(getGoodsBaseResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品会員生協情報取得 /kymw70/getGoodsCoop
  http.post(PlessService.SERVICE.KYMW70getGoodsCoop.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getGoodsCoop.url, req);
    return HttpResponse.json(getGoodsCoopResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品計画数予測取得 /kymw70/getGoodsPlanNum
  http.post(PlessService.SERVICE.KYMW70getGoodsPlanNum.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getGoodsPlanNum.url, req);
    return HttpResponse.json(getGoodsPlanNumResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 媒体リスト取得 /kymw70/getMediumListByOrder
  http.post(PlessService.SERVICE.KYMW70getMediumListByOrder.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getMediumListByOrder.url, req);
    return HttpResponse.json(getMediumListByOrderResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 表紙特集選定商品一覧取得 /kymw70/getSelectionGoodsList
  http.post(PlessService.SERVICE.getSelectionGoodsList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getSelectionGoodsList.url, req);
    return HttpResponse.json(getSelectionGoodsListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 表紙特集選定依頼一覧取得 /kymw70/getSelectionRequestList
  http.post(PlessService.SERVICE.getSelectionRequestList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getSelectionRequestList.url, req);
    return HttpResponse.json(getSelectionRequestListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品情報取得(表紙特集掲載商品選定) /kymw70/getTargetListByFeatureGoodsSelection
  http.post(PlessService.SERVICE.KYMW70getTargetListByFeatureGoodsSelection.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getTargetListByFeatureGoodsSelection.url, req);
    return HttpResponse.json(getTargetListByFeatureGoodsSelectionResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 表紙特集商品選定情報保存(企画担当) /kymw70/saveFeatureInfoByPlanner
  http.post(PlessService.SERVICE.saveFeatureInfoByPlanner.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.saveFeatureInfoByPlanner.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

];

// 特集商品選定チェック
const checkFeatureGoodsSelectionResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "PCode": "P0000002",
        "ItemCode": "0000002"
      }
    ]
  }
}

// 表紙特集商品選定情報チェックレスポンス結果
const checkFeatureSelectionResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      NormalPCodeList: [
        {"PCode": "P0000010"},
        {"PCode": "P0000011"},
        {"PCode": "P0000012"}
      ]
    }
  }
}

// 特集情報一覧取得結果
const getFeatureListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "FeatureCode": "T1",
        "FeatureName": "特集名1"
      },
      {
        "FeatureCode": "T2",
        "FeatureName": "特集名2"
      },
      {
        "FeatureCode": "T3",
        "FeatureName": "特集名3"
      },
      {
        "FeatureCode": "T4",
        "FeatureName": "特集名4"
      },
      {
        "FeatureCode": "T5",
        "FeatureName": "特集名5"
      },
    ]
  }
}

// 特集情報取得結果
const getFeatureThemaResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [{
      "Memo": "特集メモ",
      "PlannerSelectionFlag": 0
    }]
  }
}

// 商品基本情報取得
const getGoodsBaseResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      "GoodsBase": {
        "GuideGoodsName": "商品名1",
        "GuideStandardName": "規格名1"
      }
    }
  }
}

// 商品会員生協情報取得
const getGoodsCoopResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      "GoodsCoop": {
        "SupplyPriceStandard": "3000",
        "SupplyPriceSpecial1": "2000",
        "SupplyPriceSpecial2": "1000",
        "CostPriceStandard": "3000",
        "CostPriceSpecial1": "2000",
        "CostPriceSpecial2": "1000"
      }
    }
  }
}

// 商品計画数予測取得
const getGoodsPlanNumResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      "PlanNumList": [
        {
          "PCode": "P0000010",
          "PlanNumAiPrediction": "2000"
        },
        {
          "PCode": "P0000011",
          "PlanNumAiPrediction": "4000"
        },
      ]
    }
  }
}

// 媒体リスト取得
const getMediumListByOrderResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        MediumType: '001',
        MediumName: 'ハピデリ',
      },
      {
        MediumType: '003',
        MediumName: 'ぐるめぐり',
      },
      {
        MediumType: "023",
        MediumName: "コスメｄｅきれい（ＣＤ）"
      },
    ]
  }
}

// 表紙特集選定商品一覧取得
const getSelectionGoodsListResponse = {
  status: 'ok',
  message: '処理完了',
  "result": {
    "obj": {
      "SelectionList": [
        {
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "01",
          "ClassName": "部門名1部門名1",
          "MiddleClassCode": "01",
          "MiddleClassName": "中分類名1中分類名1",
          "PCode": "P0000001",
          "GuideGoodsName": "商品名1商品名1",
          "GuideStandardName": "規格名1規格名1",
          "PricePattern": "0",
          "IsChangedPricePattern": "1",
          "ThisTimeSupplyPrice": "400",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "IsChangedSupplyPrice": "0",
          "ThisTimeCostPrice": "100",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "IsChangedCostPrice": "0",
          "PredictPlanNum": "500",
          "PlanNum": "1000",
          "IsChangedPlanNum": "0",
          "PlanSupplyBudget": "800000",
          "IsChangedPlanSupplyBudget": "0",
          "TagName": "春夏秋冬春夏秋冬",
          "Remarks": "備考備考備考備考備考備考",
          "SelectorType": "0",
          "BuyerRequestId": "0000000000001",
          "ItemCode": "0000001",
          "BuyerApprovalFlag": "0",
        },
        {
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "02",
          "ClassName": "部門名1",
          "MiddleClassCode": "01",
          "MiddleClassName": "中分類名1",
          "PCode": "P0000002",
          "GuideGoodsName": "商品名2",
          "GuideStandardName": "却下",
          "PricePattern": "1",
          "IsChangedPricePattern": "0",
          "ThisTimeSupplyPrice": "300",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "IsChangedSupplyPrice": "0",
          "ThisTimeCostPrice": "200",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "IsChangedCostPrice": "1",
          "PredictPlanNum": "400",
          "PlanNum": "900",
          "IsChangedPlanNum": "0",
          "PlanSupplyBudget": "700000",
          "IsChangedPlanSupplyBudget": "0",
          "TagName": "春",
          "Remarks": "備考2",
          "SelectorType": "1",
          "BuyerRequestId": "0000000000001",
          "ItemCode": "0000001",
          "BuyerApprovalFlag": "2",
        },
        {
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "03",
          "ClassName": "部門名1",
          "MiddleClassCode": "01",
          "MiddleClassName": "中分類名1",
          "PCode": "P0000003",
          "GuideGoodsName": "商品名3",
          "GuideStandardName": "規格名3",
          "PricePattern": "2",
          "IsChangedPricePattern": "1",
          "ThisTimeSupplyPrice": "200",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "IsChangedSupplyPrice": "0",
          "ThisTimeCostPrice": "300",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "IsChangedCostPrice": "0",
          "PredictPlanNum": "",
          "PlanNum": "",
          "IsChangedPlanNum": "0",
          "PlanSupplyBudget": "600000",
          "IsChangedPlanSupplyBudget": "1",
          "TagName": "夏",
          "Remarks": "備考3",
          "SelectorType": "2",
          "BuyerRequestId": "0000000000001",
          "ItemCode": "0000001",
          "BuyerApprovalFlag": "0",
        },
        {
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "04",
          "ClassName": "部門名1",
          "MiddleClassCode": "01",
          "MiddleClassName": "中分類名1",
          "PCode": "P0000004",
          "GuideGoodsName": "商品名4",
          "GuideStandardName": "規格名4",
          "PricePattern": "3",
          "IsChangedPricePattern": "0",
          "ThisTimeSupplyPrice": "400",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "IsChangedSupplyPrice": "0",
          "ThisTimeCostPrice": "100",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "IsChangedCostPrice": "0",
          "PredictPlanNum": "200",
          "PlanNum": "700",
          "IsChangedPlanNum": "0",
          "PlanSupplyBudget": "500000",
          "IsChangedPlanSupplyBudget": "0",
          "TagName": "秋",
          "Remarks": "備考4",
          "SelectorType": "2",
          "BuyerRequestId": null,
          "ItemCode": "0000001",
          "BuyerApprovalFlag": "0",
        },
        {
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "04",
          "ClassName": "部門名1",
          "MiddleClassCode": "01",
          "MiddleClassName": "中分類名1",
          "PCode": "P0000005",
          "GuideGoodsName": "商品名5",
          "GuideStandardName": "却下",
          "PricePattern": "0",
          "IsChangedPricePattern": "0",
          "ThisTimeSupplyPrice": "300",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "IsChangedSupplyPrice": "0",
          "ThisTimeCostPrice": "200",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "IsChangedCostPrice": "0",
          "PredictPlanNum": "100",
          "PlanNum": "600",
          "IsChangedPlanNum": "0",
          "PlanSupplyBudget": "800000",
          "IsChangedPlanSupplyBudget": "0",
          "TagName": "冬",
          "Remarks": "備考5",
          "SelectorType": "3",
          "BuyerRequestId": "0000000000001",
          "ItemCode": "0000001",
          "BuyerApprovalFlag": "2",
        },
        {
          "FeatureCode": "T1",
          "FeatureName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "ClassCode": "04",
          "ClassName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "MiddleClassCode": "01",
          "MiddleClassName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "PCode": "P0000005",
          "GuideGoodsName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "GuideStandardName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "PricePattern": "0",
          "IsChangedPricePattern": "0",
          "ThisTimeSupplyPrice": "",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "IsChangedSupplyPrice": "0",
          "ThisTimeCostPrice": "200",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "IsChangedCostPrice": "0",
          "PredictPlanNum": "100",
          "PlanNum": "600",
          "IsChangedPlanNum": "0",
          "PlanSupplyBudget": "800000",
          "IsChangedPlanSupplyBudget": "0",
          "TagName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "Remarks": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "SelectorType": "3",
          "BuyerRequestId": "0000000000001",
          "ItemCode": "0000001",
          "BuyerApprovalFlag": "2",
        },
        {
          "FeatureCode": "T1",
          "FeatureName": "髙﨑😀<>",
          "ClassCode": "04",
          "ClassName": "髙﨑😀<>",
          "MiddleClassCode": "01",
          "MiddleClassName": "髙﨑😀<>",
          "PCode": "P0000005",
          "GuideGoodsName": "髙﨑😀<>",
          "GuideStandardName": "髙﨑😀<>",
          "PricePattern": "0",
          "IsChangedPricePattern": "0",
          "ThisTimeSupplyPrice": "300",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "IsChangedSupplyPrice": "0",
          "ThisTimeCostPrice": "200",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "IsChangedCostPrice": "0",
          "PredictPlanNum": "100",
          "PlanNum": "600",
          "IsChangedPlanNum": "0",
          "PlanSupplyBudget": "800000",
          "IsChangedPlanSupplyBudget": "0",
          "TagName": "髙﨑😀<>",
          "Remarks": "髙﨑😀<>",
          "SelectorType": "3",
          "BuyerRequestId": "0000000000001",
          "ItemCode": "0000001",
          "BuyerApprovalFlag": "2",
        },
        {
          "FeatureCode": "",
          "FeatureName": "",
          "ClassCode": "",
          "ClassName": "",
          "MiddleClassCode": "",
          "MiddleClassName": "",
          "PCode": "",
          "GuideGoodsName": "",
          "GuideStandardName": "",
          "PricePattern": "",
          "IsChangedPricePattern": "",
          "ThisTimeSupplyPrice": "",
          "SupplyPriceStandard": "",
          "SupplyPriceSpecial1": "",
          "SupplyPriceSpecial2": "",
          "IsChangedSupplyPrice": "",
          "ThisTimeCostPrice": "",
          "CostPriceStandard": "",
          "CostPriceSpecial1": "",
          "CostPriceSpecial2": "",
          "IsChangedCostPrice": "",
          "PredictPlanNum": "",
          "PlanNum": "",
          "IsChangedPlanNum": "",
          "PlanSupplyBudget": "",
          "IsChangedPlanSupplyBudget": "",
          "TagName": "",
          "Remarks": "",
          "SelectorType": "",
          "BuyerRequestId": "",
          "ItemCode": "",
          "BuyerApprovalFlag": "",
        },
      ]
    }
  }
}

const getSelectionGoodsListBlankResponse = {
  status: 'ok',
  message: '処理完了',
  "result": {
    "obj": {
      "SelectionList": []
    }
  }
}

// 表紙特集選定依頼一覧取得
const getSelectionRequestListResponse = {
  status: 'ok',
  message: '処理完了',
  "result": {
    "obj": {
      "FeatureRequestList": [
        {
          "BuyerRequestId": "0000000000001",
          "FeatureCode": "T1",
          "FeatureName": "特集名1特集名1",
          "ClassCode": "01",
          "ClassName": "部門名1",
          "MiddleClassCode": "0101",
          "MiddleClassName": "中分類名1",
          "PCode": "P0000001",
          "GuideGoodsName": "商品名1商品名1商品名1",
          "GuideStandardName": "規格名1規格名1規格名1",
          "PricePattern": "0",
          "ThisTimeSupplyPrice": "500",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "ThisTimeCostPrice": "500",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "PredictPlanNum": "1000",
          "PlanNum": "1000",
          "PlanSupplyBudget": "500000",
          "RequestStatus": "0",
          "Remarks": "備考1備考2備考3備考4"
        },
        {
          "BuyerRequestId": "0000000000002",
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "02",
          "ClassName": "部門名2",
          "MiddleClassCode": "0102",
          "MiddleClassName": "中分類名1",
          "PCode": "P0000002",
          "GuideGoodsName": "商品名2",
          "GuideStandardName": "規格名2",
          "PricePattern": "1",
          "ThisTimeSupplyPrice": "400",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "ThisTimeCostPrice": "400",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "PredictPlanNum": "900",
          "PlanNum": "900",
          "PlanSupplyBudget": "400000",
          "RequestStatus": "1",
          "Remarks": "備考2"
        },
        {
          "BuyerRequestId": "0000000000003",
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "02",
          "ClassName": "部門名2",
          "MiddleClassCode": "0103",
          "MiddleClassName": "中分類名1",
          "PCode": "P0000003",
          "GuideGoodsName": "商品名3",
          "GuideStandardName": "提案済",
          "PricePattern": "2",
          "ThisTimeSupplyPrice": "300",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "ThisTimeCostPrice": "300",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "PredictPlanNum": "800",
          "PlanNum": "800",
          "PlanSupplyBudget": "300000",
          "RequestStatus": "2",
          "Remarks": "備考3"
        },
        {
          "BuyerRequestId": "0000000000004",
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "03",
          "ClassName": "部門名2",
          "MiddleClassCode": "0104",
          "MiddleClassName": "中分類名1",
          "PCode": "P0000004",
          "GuideGoodsName": "商品名4",
          "GuideStandardName": "規格名4",
          "PricePattern": "3",
          "ThisTimeSupplyPrice": "200",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "ThisTimeCostPrice": "200",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "PredictPlanNum": "700",
          "PlanNum": "700",
          "PlanSupplyBudget": "200000",
          "RequestStatus": "0",
          "Remarks": "備考4"
        },
        {
          "BuyerRequestId": "0000000000005",
          "FeatureCode": "T1",
          "FeatureName": "特集名1",
          "ClassCode": "05",
          "ClassName": "部門名5",
          "MiddleClassCode": "0105",
          "MiddleClassName": "中分類名5",
          "PCode": "P0000005",
          "GuideGoodsName": "商品名5",
          "GuideStandardName": "規格名5",
          "PricePattern": "0",
          "ThisTimeSupplyPrice": "100",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "ThisTimeCostPrice": "100",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "PredictPlanNum": "600",
          "PlanNum": "600",
          "PlanSupplyBudget": "100000",
          "RequestStatus": "1",
          "Remarks": "備考5"
        },
        {
          "BuyerRequestId": "0000000000005",
          "FeatureCode": "T1",
          "FeatureName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "ClassCode": "05",
          "ClassName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "MiddleClassCode": "0105",
          "MiddleClassName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "PCode": "P0000005",
          "GuideGoodsName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "GuideStandardName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
          "PricePattern": "0",
          "ThisTimeSupplyPrice": "100",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "ThisTimeCostPrice": "100",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "PredictPlanNum": "600",
          "PlanNum": "600",
          "PlanSupplyBudget": "100000",
          "RequestStatus": "1",
          "Remarks": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ"
        },
        {
          "BuyerRequestId": "0000000000005",
          "FeatureCode": "T1",
          "FeatureName": "髙﨑😀<>",
          "ClassCode": "05",
          "ClassName": "髙﨑😀<>",
          "MiddleClassCode": "0105",
          "MiddleClassName": "髙﨑😀<>",
          "PCode": "P0000005",
          "GuideGoodsName": "髙﨑😀<>",
          "GuideStandardName": "髙﨑😀<>",
          "PricePattern": "0",
          "ThisTimeSupplyPrice": "100",
          "SupplyPriceStandard": "300",
          "SupplyPriceSpecial1": "200",
          "SupplyPriceSpecial2": "100",
          "ThisTimeCostPrice": "100",
          "CostPriceStandard": "300",
          "CostPriceSpecial1": "150",
          "CostPriceSpecial2": "100",
          "PredictPlanNum": "600",
          "PlanNum": "600",
          "PlanSupplyBudget": "100000",
          "RequestStatus": "1",
          "Remarks": "髙﨑😀<>"
        },
        {
          "BuyerRequestId": "",
          "FeatureCode": "",
          "FeatureName": "",
          "ClassCode": "",
          "ClassName": "",
          "MiddleClassCode": "",
          "MiddleClassName": "",
          "PCode": "",
          "GuideGoodsName": "",
          "GuideStandardName": "",
          "PricePattern": "",
          "ThisTimeSupplyPrice": "",
          "SupplyPriceStandard": "",
          "SupplyPriceSpecial1": "",
          "SupplyPriceSpecial2": "",
          "ThisTimeCostPrice": "",
          "CostPriceStandard": "",
          "CostPriceSpecial1": "",
          "CostPriceSpecial2": "",
          "PredictPlanNum": "",
          "PlanNum": "",
          "PlanSupplyBudget": "",
          "RequestStatus": "",
          "Remarks": ""
        },
      ]
    }
  }
}

// 商品情報取得(表紙特集掲載商品選定)
const getTargetListByFeatureGoodsSelectionResponse = {
  status: 'ok',
  message: '処理完了',
  "result": {
    "obj": [
      {
        "PCode": "P0000010",
        "ItemCode": "1234567",
        "GuideGoodsName": "商品名1商品名1商品名1商品名1",
        "GuideStandardName": "規格名1規格名1規格名1規格名1",
        "ClassCode": "01",
        "ClassNameKanji": "部門名部門名部門名部門名",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1大分類名1",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名1中分類名1",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1小分類名1",
        "TagName": "タグ名1タグ名2タグ名1タグ名2",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
      },
      {
        "PCode": "P0000011",
        "ItemCode": "1234568",
        "GuideGoodsName": "商品名2",
        "GuideStandardName": "規格名2",
        "ClassCode": "02",
        "ClassNameKanji": "部門名2",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名1",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
      },
      {
        "PCode": "P0000012",
        "ItemCode": "1234568",
        "GuideGoodsName": "予測値空",
        "GuideStandardName": "規格名2",
        "ClassCode": "02",
        "ClassNameKanji": "部門名2",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名1",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
      },
      {
        "PCode": "P0000013",
        "ItemCode": "1234568",
        "GuideGoodsName": "選定不可データ",
        "GuideStandardName": "取扱終了扱",
        "ClassCode": "02",
        "ClassNameKanji": "部門名2",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名1",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
      },
      {
        "PCode": "P0000001",
        "ItemCode": "1234568",
        "GuideGoodsName": "選定不可データ",
        "GuideStandardName": "重複",
        "ClassCode": "02",
        "ClassNameKanji": "部門名2",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名1",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
      },
      {
        "PCode": "P0000002",
        "ItemCode": "1234569",
        "GuideGoodsName": "選定済み商品",
        "GuideStandardName": "規格名",
        "ClassCode": "02",
        "ClassNameKanji": "部門名2",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名1",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
      },
      {
        "Pcode": "P0000002",
        "ItemCode": "1234569",
        "GuideGoodsName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
        "GuideStandardName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
        "ClassCode": "02",
        "ClassNameKanji": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
        "TagName": "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
      },
      {
        "Pcode": "P0000002",
        "ItemCode": "1234569",
        "GuideGoodsName": "髙﨑😀<>",
        "GuideStandardName": "髙﨑😀<>",
        "ClassCode": "02",
        "ClassNameKanji": "髙﨑😀<>",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "髙﨑😀<>",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "髙﨑😀<>",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "髙﨑😀<>",
        "TagName": "髙﨑😀<>",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
      },
      {
        "Pcode": "",
        "ItemCode": "",
        "GuideGoodsName": "",
        "GuideStandardName": "",
        "ClassCode": "",
        "ClassNameKanji": "",
        "LargeClassCode": "",
        "LargeClassNameKanji": "",
        "MiddleClassCode": "",
        "MiddleClassNameKanji": "",
        "SmallClassCode": "",
        "SmallClassNameKanji": "",
        "TagName": "",
        "SupplyPriceStandard": "",
        "SupplyPriceSpecial1": "",
        "SupplyPriceSpecial2": "",
        "CostPriceStandard": "",
        "CostPriceSpecial1": "",
        "CostPriceSpecial2": "",
      },
    ]
  }
}
